/* AppListingV2.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { fontFamily } from '@atlaskit/theme';
import { ResponsiveTabs } from '@atlassian/mpac-ui';
import React from 'react';
import { ELEMENT_ID, MAX_VISIBLE_TABS_CONFIG } from '../../../constants';
import { ListingHeader } from '../ListingHeader/ListingHeader';
const _ = "._ect41sdi{font-family:Charlie Text,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const BrandFontWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ect41sdi", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BrandFontWrapper.displayName = 'BrandFontWrapper';
}
const AppListingV2 = props => {
  const {
    appHeaderDetails,
    appRatingLink,
    appIconLink,
    bottomSeparator,
    headerInjection,
    hostingSelect,
    afterHeader,
    isAppCloudFortified,
    showStaffPickBadge,
    showInstallationCount,
    openMarketplaceLinksInNewTab,
    bugBountyParticipant,
    compatibilitySummary,
    lozenges,
    selectedTab,
    onTabChange,
    tabsData
  } = props;
  return /*#__PURE__*/React.createElement(BrandFontWrapper, null, /*#__PURE__*/React.createElement(ListingHeader, {
    appHeaderDetails: appHeaderDetails,
    appRatingLink: appRatingLink,
    appIconLink: appIconLink,
    bottomSeparator: bottomSeparator,
    headerInjection: headerInjection,
    isAppCloudFortified: isAppCloudFortified,
    showStaffPickBadge: showStaffPickBadge,
    showInstallationCount: showInstallationCount,
    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
    bugBountyParticipant: bugBountyParticipant,
    compatibilitySummary: compatibilitySummary,
    lozenges: lozenges,
    showAetherAppListingPage: true,
    hostingSelect: hostingSelect
  }), afterHeader, /*#__PURE__*/React.createElement(ResponsiveTabs, {
    id: ELEMENT_ID.APP_LISTING_TABS,
    selected: selectedTab,
    maxVisibleTabs: MAX_VISIBLE_TABS_CONFIG,
    onChange: onTabChange,
    tabs: tabsData,
    showAetherAppListingPage: true
  }));
};
export default AppListingV2;